(() => {
  const body = document.body;

  if (!body) {
    return;
  }

  const scrollThreshold = 24;
  let ticking = false;

  const updateHeader = () => {
    body.classList.toggle(
      'muchv-header-scrolled',
      window.scrollY > scrollThreshold
    );

    ticking = false;
  };

  const requestUpdate = () => {
    if (ticking) {
      return;
    }

    ticking = true;
    window.requestAnimationFrame(updateHeader);
  };

  updateHeader();

  window.addEventListener('scroll', requestUpdate, {
    passive: true
  });

  window.addEventListener('resize', requestUpdate, {
    passive: true
  });

  document.addEventListener('shopify:section:load', updateHeader);
})();